import classNames from "classnames"
import React from "react"

import type { Nullable } from "@bounce/util"

import { Link } from "../../../Navigation/Link/Link"
import type { PNImageProps } from "../../PNImage/PNImage"
import { PNImage } from "../../PNImage/PNImage"

export type PostAuthorProps = {
  href?: Nullable<string>
  name?: Nullable<string>
  image?: PNImageProps["src"]
  imageLoading?: PNImageProps["loading"]
  metadata?: Nullable<string>
  className?: string
}

export const PostAuthor = ({ href, name, image, imageLoading = "lazy", metadata, className }: PostAuthorProps) => (
  <Link href={href ?? ""} className={classNames("post-author", className)}>
    <PNImage
      data-chromatic="ignore"
      src={image}
      loader={undefined}
      width={84}
      height={84}
      loading={imageLoading}
      unoptimized
      imgixParams={{ fit: "crop", w: 84, h: 84, ar: "1:1" }}
      className="post-author__image"
    />
    <div className="flex flex-1 flex-col justify-between">
      <span className="post-author__name ">{name}</span>
      <span className="post-author__metadata">{metadata}</span>
    </div>
  </Link>
)
